export const UploadWidgetContainerId = 'upload-widget-container'
export const UploadWidgetRoot = 'upload-widget-root'
